<template>
  <v-card class="pb-3">
    <v-card-title primary-title class="pb-2 pl-1">
      <strong class="px-3">{{ title }}</strong>
      <v-divider />
      <v-btn icon flat color="grey darken-3" class="pa-0 my-0" @click="reset">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>

    <v-layout wrap justify-center>
      <v-text-field
        class="flex xs11"
        :label="$t('name')"
        v-model="role.name"
        data-vv-name="name"
        :data-vv-as="$t('name')"
        v-validate="'required|min:3'"
        :error-messages="errors.collect('name')"
      />
      <permissions
        class="flex xs11"
        :hide_actions="true"
        :permissions="role.permissions"
      />
      <v-layout row reverse class="flex xs11 pt-3">
        <v-btn
          color="btn_color secondary"
          @click="submit"
          class="ml-0"
          :loading="loading"
        >
          <span>{{ $t("save") }}</span>
        </v-btn>
      </v-layout>
    </v-layout>
  </v-card>
</template>
<script>
import permissions from "./permissions.vue";

export default {
  name: "NewRole",
  components: { permissions },
  props: {
    role: {
      default: function() {
        return {
          id: null,
          name: null,
          permissions: []
        };
      }
    }
  },

  data: () => ({
    loading: false
  }),
  computed: {
    title: vm => (vm.role.id ? vm.$t("edit_role") : vm.$t("new_role"))
  },

  methods: {
    submit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          let final_ids = [];
          this.loading = true;
          let permissions = this.role.permissions;
          for (let key in permissions) {
            if (permissions[key].value) final_ids.push(permissions[key].id);
          }

          if (final_ids.length === 0) {
            this.$store.commit("showSnackbar", {
              text: this.$t("no_permission_selected"),
              stateType: "error",
              show: true
            });
            this.loading = false;
          } else {
            this.axios
              .post("roles", {
                id: this.role.id,
                name: this.role.name,
                permissions: final_ids
              })
              .then(res => {
                this.$store.commit("showSnackbar", {
                  text: this.$t("save_succeed"),
                  stateType: "success",
                  show: true
                });
                this.$emit("saved", res.data.data);
                this.loading = false;
              });
          }
        } else {
          this.$store.commit("showSnackbar", {
            text: this.$t("wrong_input_alert"),
            stateType: "error",
            show: true
          });
          this.loading = false;
        }
      });
    },

    reset() {
      this.$emit("closed");
    }
  }
};
</script>
